export default __webpack_public_path__ + "static/15_21-1--4845caaeecd4a01b0611d85ff3c0ca08.png";